import React from 'react';
import { dateFormat, formatHours, formatNumber } from '../../helpers/stringFormat';
import Dots from '../Dots';
import Avatar from '../Avatar';
import { Tooltip } from 'antd'

const Card = (props) => {
    return (
        <div className='job-card'>
            <div className='card-color' style={{ backgroundColor: `${props?.colorList?.data?.find(data => { return data?.id == props?.data?.color_id }) != undefined ? props?.colorList?.data?.find(data => { return data?.id == props?.data?.color_id })['color'] : ''}` }} />
            <div className='w-100 mb-2 mt-2 d-flex flex-column'>
                <b className="card-number">
                    #{props.data.ro_number}
                </b>
                <span className='card-extra-small-text'>{`${props?.data?.in_date ? dateFormat(props?.data?.in_date, 'INOUT_DATE') : '-'} / ${props.data.out_date ? dateFormat(props.data.out_date, 'INOUT_DATE') : '-'}`}</span>
                <div className='card-name'>
                    
                    {props.canSeeJobCustomerName && (
                        <p className='card-name-value'>{props.data.customer != null ? props.data.customer.firstname : ''} {props.data.customer != null ? props.data.customer.lastname : ''}</p>
                    )}
                    
                    <p className='sub-text'>{props.data.vehicle?.year} {props.data.vehicle?.make?.name} {props.data.vehicle?.model}</p>
                    <p className='sub-text'>{props.data?.insurance_company}</p>
                </div>
                <div className='content-bottom'>
                    <div className='d-flex justify-content-between w-100 card-value'>
                        <Tooltip
                            title={`Frame hours: ${props.data.frame_hours ? parseFloat((props.data.frame_hours).toString()) + 'h' : '0h'}\nPaint hours: ${props.data.paint_hours ? parseFloat((props.data.paint_hours).toString()) + 'h' : '0h'}`}
                            mouseEnterDelay={0.5}
                            overlayStyle={{ whiteSpace: 'pre-line' }}
                        >
                            <span>{props.data.frame_hours ? formatHours(props.data.frame_hours, 'h') : '0h'} / {props.data.paint_hours ? formatHours(props.data.paint_hours, 'h') : '0h'}</span>
                        </Tooltip>
                        <span>{props?.data?.value ? `${formatNumber(props.data.value, 2, '$')}` : ''}</span>
                    </div>

                    {props.canUpdateJobDot && (
                        <div className='dots-container'>
                            <Dots defaultValue={props?.data?.dots_bits ? Array.from(props.data.dots_bits) : []} jobData={props.data} isFilter={false} canUpdateJobDot={props.canUpdateJobDot} />
                        </div>
                    )}

                    <div className='card-footer'>
                        <div className='section-left'>
                            <div className={`left-content ${props.data?.has_unread_notes === 0 && 'disabled'}`}>
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.25 8.75C12.25 9.05942 12.1271 9.35616 11.9083 9.57496C11.6895 9.79375 11.3928 9.91667 11.0833 9.91667H4.08333L1.75 12.25V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H11.0833C11.3928 1.75 11.6895 1.87292 11.9083 2.09171C12.1271 2.3105 12.25 2.60725 12.25 2.91667V8.75Z" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span>{props.data?.has_unread_notes}</span>
                            </div>
                            <div className={`left-content ${props.data.has_files === 0 && 'disabled'}`}>
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.71875 11.8135L12.2489 7.1748" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9.33363 3.49983L4.42546 8.50833C4.20675 8.72711 4.08388 9.0238 4.08388 9.33316C4.08388 9.64252 4.20675 9.93921 4.42546 10.158C4.64425 10.3767 4.94094 10.4996 5.2503 10.4996C5.55965 10.4996 5.85635 10.3767 6.07513 10.158L10.9833 5.14949C11.4207 4.71193 11.6665 4.11854 11.6665 3.49983C11.6665 2.88111 11.4207 2.28773 10.9833 1.85016C10.5457 1.41273 9.95235 1.16699 9.33363 1.16699C8.71491 1.16699 8.12153 1.41273 7.68396 1.85016L2.77521 6.85808C2.11878 7.51451 1.75 8.40482 1.75 9.33316C1.75 10.2615 2.11878 11.1518 2.77521 11.8082C3.43165 12.4647 4.32196 12.8335 5.2503 12.8335C6.17863 12.8335 7.06895 12.4647 7.72538 11.8082" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span>{props.data.has_files}</span>
                            </div>
                        </div>
                        {props?.data?.assigned_to_user &&
                            <Avatar
                                userImage={props?.data?.assigned_to_user?.avatar}
                                userName={props?.data?.assigned_to_user}
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Card;